

/**
 * Builds a filled SVG area path between two y-value arrays.
 * For each contiguous run of points where `condition(i)` is true, one closed
 * polygon is emitted: a forward pass along `y_fwd` then a backward pass along
 * `y_bwd`, with entry/exit positions interpolated at run boundaries.
 */
export function build_area_path(
    xs: number[],
    y_fwd: number[],
    y_bwd: number[],
    condition: (i: number) => boolean,
): string
{
    const n = xs.length
    if (n < 2) return ""

    const parts: string[] = []

    const emit_run = (start: number, end: number) =>
    {
        const cmds: string[] = []

        // ── forward pass (y_fwd) ────────────────────────────────────────────

        // // interpolated entry point
        // if (start > 0)
        // {
        //     const ex = (xs[start - 1]! + xs[start]!) / 2
        //     const ey = (y_fwd[start - 1]! + y_fwd[start]!) / 2
        //     cmds.push(`M${ex.toFixed(1)},${ey.toFixed(1)}`)
        // }
        // else
        // {
            cmds.push(`M${xs[start]!.toFixed(1)},${y_fwd[start]!.toFixed(1)}`)
        // }

        for (let j = start; j <= end; j++)
        {
            cmds.push(`L${xs[j]!.toFixed(1)},${y_fwd[j]!.toFixed(1)}`)
        }
        // interpolated exit point (forward)
        // if (end < n - 1)
        // {
        //     const ex = (xs[end]! + xs[end + 1]!) / 2
        //     cmds.push(`L${ex.toFixed(1)},${((y_fwd[end]! + y_fwd[end + 1]!) / 2).toFixed(1)}`)
        //     // pivot to backward line at the same exit x
        //     cmds.push(`L${ex.toFixed(1)},${((y_bwd[end]! + y_bwd[end + 1]!) / 2).toFixed(1)}`)
        // }
        // else
        // {
            cmds.push(`L${xs[end]!.toFixed(1)},${y_bwd[end]!.toFixed(1)}`)
        // }

        // ── backward pass (y_bwd) ───────────────────────────────────────────
        for (let j = end - 1; j >= start; j--)
        {
            cmds.push(`L${xs[j]!.toFixed(1)},${y_bwd[j]!.toFixed(1)}`)
        }
        // back to entry point (backward)
        const start_index = start > 0 ? start - 1 : start
        cmds.push(`L${xs[start_index]!.toFixed(1)},${(y_bwd[start_index]!).toFixed(1)}`)
        cmds.push("Z")
        parts.push(cmds.join(" "))
    }

    let run_start = -1
    for (let i = 0; i <= n; i++)
    {
        const active = i < n && condition(i)
        if (active && run_start === -1) run_start = i
        else if (!active && run_start !== -1)
        {
            emit_run(run_start, i - 1)
            run_start = -1
        }
    }

    return parts.join(" ")
}
